import * as React from 'react';
export const VCSvg = React.forwardRef(function VCSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M2.005 2H4v12H2.005C.894 14 0 13.1 0 11.991V4.01A2.01 2.01 0 0 1 2.005 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M12 2h1.995C15.106 2 16 2.9 16 4.009v7.982A2.008 2.008 0 0 1 13.995 14H12V2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M4 2h8v12H4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M8 8.586 9.414 10 8 11.414 6.586 10 8 8.586Zm2-2L11.414 8 10 9.414 8.586 8 10 6.586Zm-4 0L7.414 8 6 9.414 4.586 8 6 6.586Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M4 14v-1h8v1H4ZM4 2h8v1H4V2Z',
      }),
    ),
  );
});
VCSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var VC = {
  category: 'flag',
  colorable: false,
  name: 'VC',
  svg: VCSvg,
};
